import { render, staticRenderFns } from "./lk-course-info.vue?vue&type=template&id=6666ea7c&"
import script from "./lk-course-info.vue?vue&type=script&lang=js&"
export * from "./lk-course-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-course/lk-course-info/lk-course-info.vue
// module id = 1201
// module chunks = 0